var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tdt-container"},[_c('div',{staticClass:"tdtMapView",attrs:{"id":"mapContainer"}}),(_vm.mapLoaded)?_c('div',{staticClass:"tdtMapOverlay",style:({ left: _vm.pos.x + 'px', top: _vm.pos.y + 'px' })},[_c('i',{staticClass:"iconfont icon-dizhi"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }